import { CHECKOUT_PATH } from "../../../common/constants";
import { CHECKOUT_ROUTES } from "../../checkout.routes";
export const CHECKOUT_PAYMENT_UI = {
    ADD_SHIPPING_ADDRESS_MODAL_TITLE: "Add shipping address",
    ADD_BILLING_ADDRESS_MODAL_TITLE: "Add billing address",
    SELECT_PAYMENT_METHOD_REQUIRED:
        "Please select a payment method before placing your order.",
} as const;

export const CHECKOUT_PAYMENT_ERRORS = {
    ACTIVE_ORDER_CODE_MISSING: "Active order code is missing.",
} as const;

export const STRIPE_PAYMENT_ELEMENT_DOM_ID = "payment-element";

export const POST_PAYMENT_ACTIVE_ORDER_CLEAR_DELAY_MS = 500;

export const APOLLO_FETCH_POLICY = {
    NETWORK_ONLY: "network-only",
} as const;

export const STATE_SERVICE_KEY = {
    ACTIVE_ORDER_ID: "activeOrderId",
    CLIENT_SECRET: "clientSecret",
} as const;

export function checkoutConfirmationRelativePath(orderCode: string): string {
    return `../confirmation/${orderCode}`;
}

export const CHECKOUT_PAYMENT_GROUPING = {
    UNKNOWN_SUPPLIER_ID: "unknown",
    UNKNOWN_SUPPLIER_LABEL: "Unknown Supplier",
} as const;

export const CHECKOUT_PAYMENT_FACET = {
    BRAND: "brand",
} as const;

export const CHECKOUT_PAYMENT_SUPPLY = {
    PRE_ORDER_NORMALIZED: "pre-order",
} as const;

export const CHECKOUT_STRIPE_MESSAGES = {
    PUBLISHABLE_KEY_UNAVAILABLE:
        "Stripe publishable key not available. Please contact support.",
    LOAD_FAILED:
        "Failed to load Stripe. Please check your internet connection and try again.",
    INIT_FAILED: "Failed to initialize payment system. Please try again.",
    PAYMENT_FAILED_TRY_AGAIN: "Payment failed try again",
    PAYMENT_ERROR: "Payment error",
} as const;

export const STRIPE_JS = {
    ELEMENT_TYPE_PAYMENT: "payment",
    REDIRECT_IF_REQUIRED: "if_required",
} as const;

export const STRIPE_METHOD_CODE_SUBSTRING = "stripe";

export function stripeConfirmationReturnUrl(
    origin: string,
    activeOrderCode: string | undefined
): string {
    if (activeOrderCode) {
        return `${origin}/${CHECKOUT_PATH}/${CHECKOUT_ROUTES.CONFIRMATION}/${activeOrderCode}`;
    }
    return `${origin}/account/orders`;
}

export function stripeConfirmationRouterPath(orderCode: string): string {
    return `/${CHECKOUT_PATH}/${CHECKOUT_ROUTES.CONFIRMATION}/${orderCode}`;
}
